import { createHttpLink } from "@apollo/client";
import { getEnv } from "utils";

const API = getEnv("REACT_APP_API_URL");

export const httpLink = createHttpLink({ uri: API });
